// SSO Error Page - displayed when backend cannot complete the OIDC flow
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ERROR_HINTS = {
  invalid_state: 'Your sign-in attempt expired or was tampered with. Please try again.',
  expired_state: 'The sign-in window timed out. Please try again.',
  token_exchange_failed: 'The identity provider rejected the authorization code.',
  token_endpoint_unreachable: 'The identity provider was unreachable. Please try again shortly.',
  id_token_invalid: 'The identity token could not be verified.',
  missing_id_token: 'The identity provider did not return an identity token.',
  no_jwks_uri: 'The identity provider did not publish signing keys.',
  no_email_claim: 'Your identity provider did not release an email address required for provisioning.',
  access_denied: 'You declined to share credentials with the application.',
};

export const SSOErrorPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const error = params.get('error') || 'unknown_error';
  const description = params.get('description') || '';
  const hint = ERROR_HINTS[error];

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F3F4F6]" data-testid="sso-error-page">
      <div className="bg-white border border-[#E5E7EB] rounded-lg shadow-sm px-10 py-10 max-w-md w-full">
        <div className="flex items-center gap-3 mb-4">
          <svg className="w-8 h-8 text-[#DC2626]" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
          <h1 className="text-xl font-semibold text-[#1B2A4A]">SSO Sign-in Failed</h1>
        </div>
        <p className="text-sm text-[#374151] mb-2" data-testid="sso-error-code">
          <span className="font-semibold">Error code:</span> {error}
        </p>
        {hint && (
          <p className="text-sm text-[#374151] mb-4" data-testid="sso-error-hint">{hint}</p>
        )}
        {description && (
          <p className="text-xs text-[#6B7280] mb-6 break-words" data-testid="sso-error-description">
            {description}
          </p>
        )}
        <button
          data-testid="sso-error-return-btn"
          onClick={() => navigate('/login', { replace: true })}
          className="w-full h-11 bg-[#1B2A4A] hover:bg-[#2D3F5F] text-white text-sm font-semibold rounded"
        >
          Return to sign in
        </button>
      </div>
    </div>
  );
};
